var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qrcode',{attrs:{"value":_vm.otpauth,"options":{ width: _vm.width, margin: _vm.margin }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }